import React, { useEffect } from "react";

export default function AppRedirect() {
  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const queryParams = window.location.search;

    const detectPlatform = (userAgent) => {
      const ua = userAgent.toLowerCase();
      if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod")) {
        return "ios";
      } else if (ua.includes("macintosh")) {
        return "mac";
      } else if (ua.includes("android")) {
        return "android";
      } else {
        return "other";
      }
    };

    const platform = detectPlatform(userAgent);

    const googlePlayLink = `https://play.google.com/store/apps/details?id=in.agrizy.app&referrer=${encodeURIComponent(queryParams)}`;
    const iOSLink = `https://apps.apple.com/in/app/agrizy/id6447946426?${encodeURIComponent(queryParams)}`;

    const redirectLink = (platform === "ios" || platform === "mac") ? iOSLink : googlePlayLink;

    // Optionally log visit - can replace with fetch POST to your server if needed
    // fetch("/api/log_visit", { method: "POST" });

    window.location.href = redirectLink;
  }, []);

  return (
    <main className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold">Redirecting you to the app store...</h1>
    </main>
  );
}
